import React, { useState } from 'react'
import TablesContainer from './container'
import TablesModal from 'components/Modal/TablesModal';
import { useAddTempReservationMutation, useAddVendorTablesMutation, useBlockVendorTablesMutation, useChangeVendorTableMutation, useGetTablesQuery, useMergeVendorTablesMutation, useReleaseTempReservationMutation, useSplitVendorTablesMutation, useUnblockVendorTablesMutation, useUpdateVendorTablesMutation, useDeleteVendorTablesMutation, useGenerateTableQRCodeMutation } from './services';
import { useSelector } from 'react-redux';
import { formatCurrency } from 'utils/function';
import { getBtnText, getInfoText, TABLE_STATUSES } from 'utils/constant';
import ConfirmationDialog from 'components/Modal/ConfirmationDialog/ConfirmationDialog';
import MergeTableDialog from 'components/Modal/MergeTableDialog';
import OrderDialogManager from 'components/Modal/OrderDialog/OrderDialogManager';
import { useOrder } from 'context/OrderContext';
import ReserveTableModal from 'components/Modal/ReserveTable';
import { useNavigate } from 'react-router-dom';
import { useCreateTableOrderMutation } from 'pages/orders/services';
import ChangeTableModal from 'components/Modal/ChangeTable';
import ViewQrModal from 'components/Modal/ViewQrModal';
import { useSocket } from 'context/SocketContext';
import { useEffect } from 'react';

const Tables = () => {
    const loginData = useSelector((state) => state?.posData);
    const { openDialog, resetOrder } = useOrder();
    const navigate = useNavigate();
    const [openModal, setOpenModal] = useState(false);
    const [editingPoints, setEditingPoints] = useState(null);
    const [currentTable, setCurrentTable] = useState(null);
    const [isConfirmOpen, setIsConfirmOpen] = useState(false);
    const [confirmAction, setConfirmAction] = useState(null); // 'block' | 'unblock' | 'split'
    const [selectedTable, setSelectedTable] = useState(null);
    const [isMergeDialogOpen, setIsMergeDialogOpen] = useState(false);
    const [mergeParentTable, setMergeParentTable] = useState(null);
    const [openReserve, setOpenReserve] = useState(false);
    const [reserveData, setReserveData] = useState(null);
    const [isChangeTableOpen, setIsChangeTableOpen] = useState(false);
    const [changeTableData, setChangeTableData] = useState(null);
    const [isViewQrOpen, setIsViewQrOpen] = useState(false);
    const [qrTableData, setQrTableData] = useState(null);

    const socket = useSocket();
    const { data: tablesList, refetch, isLoading, isFetching } = useGetTablesQuery();
    const isTableDataLoading = isLoading || (isFetching && !tablesList?.data);

    useEffect(() => {
        if (!socket) return;

        const handleTableUpdate = (data) => {
            console.log("Real-time table update received:", data);
            refetch();
        };

        socket.on("table_status_update", handleTableUpdate);
        socket.on("order_status_update", handleTableUpdate); // Many orders affect tables

        return () => {
            socket.off("table_status_update", handleTableUpdate);
            socket.off("order_status_update", handleTableUpdate);
        };
    }, [socket, refetch]);
    const [addTables, { isLoading: adding }] = useAddVendorTablesMutation();
    const [updateTables, { isLoading: updating }] = useUpdateVendorTablesMutation();

    const [blockTableApi] = useBlockVendorTablesMutation();
    const [unblockTableApi] = useUnblockVendorTablesMutation();
    const [splitTableApi] = useSplitVendorTablesMutation();
    const [mergeTableApi] = useMergeVendorTablesMutation();
    const [tempReservationApi] = useAddTempReservationMutation();
    const [releaseTempReservationApi] = useReleaseTempReservationMutation();
    const [createTableOrderAPI] = useCreateTableOrderMutation();
    const [changeTableApi, { isLoading: isChangingTable }] = useChangeVendorTableMutation();
    const [deleteTableApi] = useDeleteVendorTablesMutation();
    const [generateQrApi] = useGenerateTableQRCodeMutation();

    const handleGenerateQr = async (table) => {
        try {
            await generateQrApi({ table_id: table.id }).unwrap();
        } catch (error) {
            console.error("Error generating QR code:", error);
        }
    };

    const handleViewQr = (table) => {
        setQrTableData(table);
        setIsViewQrOpen(true);
    };


    const orderSummary = [
        {
            id: "1",
            title: "Available Tables",
            value: `${tablesList?.data?.summary?.available}`,
            // value: `9/15`,
            highlight: true,
        },
        {
            id: "2",
            title: "Occupied Tables",
            value: `${tablesList?.data?.summary?.occupied || 0}`,
            // value: `5`,
            highlight: true,
        },
        {
            id: "3",
            title: "Reserved Tables",
            value: `${tablesList?.data?.summary?.reserved || 0}`,
            highlight: true,
        },
        {
            id: "4",
            title: "Average Turn Time",
            // value: `${calendarData?.data?.stats?.availableTablesNow || 0}/${calendarData?.data?.stats?.totalTables || 0}`,
            value: `1h`,
            highlight: true,
        },
        {
            id: "5",
            title: "Today’s Revenue",
            // value: formatCurrency(
            //             calendarData?.data?.stats?.todayRevenue || 0,
            //             userData?.vendor?.currency
            //         ),
            value: formatCurrency(
                tablesList?.data?.summary?.todayRevenue || 0,
                loginData?.vendor?.currency
            ),
            highlight: true,
        },
    ]

    const openConfirmDialog = (action, table) => {
        setConfirmAction(action);
        setSelectedTable(table);
        setIsConfirmOpen(true);
    };


    const handleReserve    = (table) => {
        setOpenReserve(true);
        setReserveData(table);
    }
    const handleBlock      = (table) => openConfirmDialog('block', table);
    const handleMerge      = (table) => {
        setMergeParentTable(table);
        setIsMergeDialogOpen(true);
    }
    const handleCreate = async (table) => {
        if(table?.status == "reserved"){
            let child_ids = [];
            const nowIso = new Date().toISOString();  // e.g. "2025-07-14T10:30:45.123Z"
            const booking_date = nowIso.split('T')[0];      // "2025-07-14"
            const booking_time = nowIso.split('T')[1].split('.')[0]; // "10:30:45"
            if(table?.merged){
                table?.children?.map((ele) =>{
                    child_ids.push(ele?.id)
                })
            }
            const payload = {
                customer_id: table?.reservation?.customer_id,
                table_id: table?.id,
                booking_date: booking_date,
                booking_time: booking_time,
                guest_count: table?.reservation?.guest_count,
                child_table_ids: child_ids
            }
            const res = await createTableOrderAPI(payload);
            resetOrder();
            if(res?.data?.data){
                // navigate("/order-details", {state:{orderId: res?.data?.data?.order?.id}});
                navigate("/add-item-order", {state:{orderId: res?.data?.data?.order?.id}});
            }
        } else{
            openDialog('dineIn', {table: table})
        }
    }
    const handleView       = (table) => {
        navigate("/order-details", {state: {orderId: table?.reservation?.orderId}})
    };
    const handleUnblock    = (table) => openConfirmDialog('unblock', table);
    const handleSplit      = (table) => openConfirmDialog('split', table);


    const handleConfirmAction = async () => {
        try {
            if (confirmAction === 'block') {
                const res = await blockTableApi({ table_ids: selectedTable?.id });
                // Call your block table API/mutation
            } else if (confirmAction === 'unblock') {
                // Call your unblock table API/mutation
                const res = await unblockTableApi({ table_ids: selectedTable?.id });
            } else if (confirmAction === 'split') {
                const childIds = selectedTable?.children?.map(child => child.id) || [];
                const res = await splitTableApi({ child_ids: childIds });
            } else if (confirmAction === 'release') {
                await releaseTempReservationApi({ id: selectedTable?.reservation?.id });
            } else if (confirmAction === 'delete') {
                await deleteTableApi(selectedTable?.id);
            }
            setIsConfirmOpen(false);
            setConfirmAction(null);
            setSelectedTable(null);
        } catch (error) {
            console.error(error);
        }
    };

    const handleMergeTables = async ({ parent_id, child_ids }) => {
        try {
            const res = await mergeTableApi({ parent_id, child_ids });
            setIsMergeDialogOpen(false);
        } catch (error) {
            console.error("Error merging tables:", error);
        }
    };

    const handleReserveSubmit = async (data) => {
        try {
            const res = await tempReservationApi(data)
            if (res?.data?.status == 200) {
                setOpenReserve(false)
            }
        } catch (err) {
            console.log("Error in tempReservaiton", err);
        }
    }

    const handleRelease = (data) => {
        if (data?.status === TABLE_STATUSES.OCCUPIED || data?.status === TABLE_STATUSES.SCHEDULED) {
            setChangeTableData(data);
            setIsChangeTableOpen(true);
        } else {
            // Ask for confirmation for release
            setConfirmAction('release');
            setSelectedTable(data);
            setIsConfirmOpen(true);
        }
    }

    const handleDelete = (table) => {
        setConfirmAction('delete');
        setSelectedTable(table);
        setIsConfirmOpen(true);
    }

    const handleChangeTableSubmit = async (values) => {
        try {
            const res = await changeTableApi(values);
            if (res?.data?.status === 200) {
                setIsChangeTableOpen(false);
                setChangeTableData(null);
            }
        } catch (error) {
            console.error("Error in changeTable", error);
        }
    }

    const confirmRelease = async (data) => {
        try{
            const res = await releaseTempReservationApi({id: data?.reservation?.id});
        }catch(error){
            console.log("Error in release table", error);
        }
    }

    const handleOpenDialog = () => {
        setOpenModal(true);
        setEditingPoints(null);
    }

    const handleCloseModal = () => {
        setOpenModal(false);
        setEditingPoints(null);
    }

    const handleEdit = (point) => {
        setEditingPoints(point);
        setOpenModal(true);
    };

    const handleSubmit = async (values, { setSubmitting, setErrors }) => {
        try {
            if (editingPoints) {
                await updateTables({ id: editingPoints.id, ...values }).unwrap();
            } else {
                await addTables(values).unwrap();
            }
            handleCloseModal();
        } catch (error) {
            setErrors(error.data?.errors || {});
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <>
            <TablesContainer
                handleOpenDialog={handleOpenDialog}
                loginData={loginData}
                orderSummary={orderSummary}
                tableListData={tablesList?.data?.tables}
                isLoading={isTableDataLoading}

                onEdit={handleEdit}
                onReserve={handleReserve}
                onBlock={handleBlock}
                onMerge={handleMerge}
                onCreateOrder={handleCreate}
                onViewOrder={handleView}
                onUnblock={handleUnblock}
                onSplit={handleSplit}
                onRelease={handleRelease}
                onDelete={handleDelete}
                onGenerateQr={handleGenerateQr}
                onViewQr={handleViewQr}
            />

            <TablesModal
                open={openModal}
                onClose={handleCloseModal}
                initialData={editingPoints}
                onSubmit={handleSubmit}
                loading={adding || updating}
            />

            <OrderDialogManager />

            <ConfirmationDialog
                open={isConfirmOpen}
                handleClose={() => setIsConfirmOpen(false)}
                handleConfirm={handleConfirmAction}
                btnText={getBtnText(confirmAction)}
                infoText={getInfoText(confirmAction, selectedTable)}
                isLoading={false} // or true if using loading states from API
                action={confirmAction}
            />

            <MergeTableDialog
                open={isMergeDialogOpen}
                onClose={() => setIsMergeDialogOpen(false)}
                parentTable={mergeParentTable}
                tables={tablesList?.data?.tables || []}
                onMerge={handleMergeTables}
            />

            <ReserveTableModal
                open={openReserve}
                onClose={() => setOpenReserve(false)}
                initialData={reserveData}
                onSubmit={handleReserveSubmit}
            />

            <ChangeTableModal
                open={isChangeTableOpen}
                onClose={() => setIsChangeTableOpen(false)}
                tableData={changeTableData}
                onSubmit={handleChangeTableSubmit}
                loading={isChangingTable}
            />

            <ViewQrModal
                open={isViewQrOpen}
                onClose={() => setIsViewQrOpen(false)}
                table={qrTableData}
            />
        </>
    )
}

export default Tables
